// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__eocKx","label":"TextInput_label__l0dyP"};